// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__c7pX-","photographer":"gallery_photographer__Kq1PS"};